import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { LibModuleModule } from './lib-module/lib-module.module';
import { FetchDataService } from './services/fetch-data.service';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { FormData } from './services/form-data.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    LibModuleModule,
    InMemoryWebApiModule.forRoot(FormData)
  ],
  exports: [LibModuleModule, HttpClientModule],
  providers: [FetchDataService]
})
export class FramworkFormGeneratorModule {}
